import { render, staticRenderFns } from "./SfSteps.vue?vue&type=template&id=08e89527"
import script from "./SfSteps.vue?vue&type=script&lang=js"
export * from "./SfSteps.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfSteps.vue?vue&type=style&index=0&id=08e89527&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "6d9e22dc"
  
)

export default component.exports